<i18n src="@/lang/defaults-i18n.yaml"></i18n>
<i18n src="./dialog-register-equipment-i18n.yaml"></i18n>
<template>
    <div>
        <base-dialog
            :value="dialog"
            @input="$emit('input', $event)"
            :title="title"
            max-width="700"
            icon="mdi-information-outline"
        >
            <template v-slot:content>
                <v-container>
                    <v-row dense>
                        <v-col cols="12">
                            <!-- Objekttyp auswählen -->
                            <div
                                class="caption"
                                v-html="$t('object-type-caption')"
                            ></div>
                            <base-select
                                v-model="objectType"
                                :items="objectTypeItems"
                                :error-messages="objectTypeErrors"
                                :label="$t('object-type-label')"
                                :placeholder="$t('object-type-placeholder')"
                                :required="isRequiredField($v.objectType)"
                                dense
                                clearable
                                :item-text="
                                    (item) =>
                                        $t(`task-object-type-${item.value}`)
                                "
                            >
                                <template v-slot:prepend-item>
                                    <div
                                        class="text-body-1 pl-3"
                                        v-html="$t('object-type-label')"
                                    ></div>
                                    <v-divider></v-divider>
                                </template>
                            </base-select>
                        </v-col>
                        <v-col
                            cols="12"
                            v-if="displayDownload"
                        >
                            <base-alert type="info" dense
                                >{{ $t("download-pdf-msg") }}
                            </base-alert>
                            <app-btn-split
                                color="regOfficeBtnPrimary"
                                :items="downloadPdfBtnItems"
                                @click="
                                    onClickDownloadPdfBtnActionClick(
                                        downloadPdfActions.DOWNLOAD_PDF_DE
                                    )
                                "
                                @list:click="
                                    (item) =>
                                        onClickDownloadPdfBtnActionClick(
                                            item.actionId
                                        )
                                "
                                ><v-icon left>mdi-content-save</v-icon
                                >{{ $t("btn-download-pdf-de") }}</app-btn-split
                            >
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template
                v-slot:actions
                v-if="isTask"
            >
                <v-spacer />
                <base-btn
                    @click="createTask"
                    type="primary"
                    btnIcon="'mdi-arrow-right'"
                >
                    {{ $t("btn-continue") }}
                </base-btn>
            </template>
        </base-dialog>
        <DialogCreateTask
            ref="formCreate"
            :value="dialogCreateTask"
            :objectType="objectType"
            @input="dialogCreateTask = $event"
        >
        </DialogCreateTask>
    </div>
</template>
<script>
import { OBJECT_TYPES } from "@/data/globals.js";
import validateMixin from "@/mixins/validate";
import { required } from "vuelidate/lib/validators";
const downloadPdfActions = {
    DOWNLOAD_PDF_DE: "DOWNLOAD_PDF_DE",
    DOWNLOAD_PDF_FR: "DOWNLOAD_PDF_FR",
    DOWNLOAD_PDF_IT: "DOWNLOAD_PDF_IT"
};
export default {
    name: "DialogRegisterEquipment",
    mixins: [validateMixin],
    components: {
        DialogCreateTask: () =>
            import("@/components/tasks/create/modal-stepper.vue")
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    validations: {
        objectType: { required }
    },
    data: () => ({
        dialog: false,
        objectType: null,
        OBJECT_TYPES,
        downloadPdfActions,
        dialogCreateTask: false,
        objectTypeItems: [
            {
                value: OBJECT_TYPES.PRESSURE_EQUIPMENT
            },
            {
                value: OBJECT_TYPES.FIRE_BOTTLES_EQUIPMENT
            },
            {
                value: OBJECT_TYPES.PIPES_STEAM_HOT_WATER
            }
        ]
    }),
    computed: {
        title() {
            let title = this.$t('title');
            if (this.objectType) {
                title += ' (' + this.$t('object-type-title-' + this.objectType) + ')';
            }
            return title
        },
        objectTypeErrors() {
            const errors = [];
            if (!this.$v.objectType.$dirty) {
                return errors;
            }
            if (!this.$v.objectType.required) {
                errors.push(this.$t("field-required"));
            }
            return errors;
        },
        downloadPdfBtnItems() {
            return [
                {
                    text: this.$t("btn-download-pdf-fr"),
                    actionId: downloadPdfActions.DOWNLOAD_PDF_FR
                },
                {
                    text: this.$t("btn-download-pdf-it"),
                    actionId: downloadPdfActions.DOWNLOAD_PDF_IT
                }
            ];
        },
        isTask() {
            if (this.objectType === OBJECT_TYPES.PRESSURE_EQUIPMENT) {
                return true;
            }
            if (this.objectType === OBJECT_TYPES.FIRE_BOTTLES_EQUIPMENT) {
                return true;
            }
            return false;
        },
        displayDownload() {
            if (this.objectType === OBJECT_TYPES.PIPES_STEAM_HOT_WATER) {
                return true;
            }
            return false;
        }
    },
    methods: {
        reset() {
            this.objectType = null;
        },
        closeDialog() {
            this.dialog = false;
            this.$emit("input", this.dialog);
        },
        onClickDownloadPdfBtnActionClick(action) {
            switch (action) {
                case downloadPdfActions.DOWNLOAD_PDF_FR:
                    this.downloadFile("88268_fr.pdf");
                    break;
                case downloadPdfActions.DOWNLOAD_PDF_IT:
                    this.downloadFile("88268_it.pdf");
                    break;
                default:
                    this.downloadFile("88268_de.pdf");
                    break;
            }
        },
        createTask() {
            this.dialogCreateTask = true;
            this.closeDialog();
        },
        downloadFile(filename) {
            const link = document.createElement("a");
            link.href = `/files/${filename}`;
            link.setAttribute("download", filename);
            link.click();
        }
    },
    watch: {
        value: {
            handler: function (newValue) {
                if (newValue === true) {
                    this.reset();
                }
                this.dialog = newValue;
            },
            immediate: true
        }
    }
};
</script>
